<div class="date" *ngIf="!isSameDayThanPrevious">
  {{ storageMovement.createdAt | date: 'dd/MM/yyyy' }}
</div>
<div class="card">
  <div class="card__header">
    <div class="card__header__title">
      <img [src]="createdByAvatarUrl" [alt]="createdByName" class="card__header__title__avatar" />
      <mat-icon class="card__header__title__icon" [ngClass]="storageMovementType">swap_horiz</mat-icon>
      <p class="card__header__title__text">
        <span>Movimentação de</span>
        <span>&nbsp;</span>
        <span [class]="storageMovementType">{{ storageMovement.type | translateStorageMovementType | lowercase }}</span>
        <span>&nbsp;</span>
        <span>registrada por {{ createdByName }}</span>
      </p>
    </div>
    <div class="card__header__time">
      {{ storageMovement.createdAt | date: 'HH:mm' }}
    </div>
  </div>
  <div class="card__body">
    <div class="card__body__product">
      <img
        class="card__body__product__avatar"
        *ngIf="storageMovement.product.imageUrl; else noIcon"
        [src]="storageMovement.product.imageUrl || './assets/icon/product.svg'"
        [alt]="storageMovement.product.name"
      />
      <ng-template #noIcon>
        <mat-icon class="card__body__product__avatar" svgIcon="product">product</mat-icon>
      </ng-template>
      <div>{{ storageMovement.product.name }}</div>
    </div>
    <div class="card__body__quantity">
      <div class="card__body__quantity__text">
        <ng-container *ngIf="storageMovement.relatedStorageMovement">
          <ng-container *ngIf="storageMovement.type.includes('entry')">
            <div>Origem: {{ storageMovement.relatedStorageMovement?.storage?.name }}</div>
            <div>Destino: {{ storageMovement.storage?.name }}</div>
          </ng-container>
          <ng-container *ngIf="storageMovement.type.includes('removal')">
            <div>Origem: {{ storageMovement.storage?.name }}</div>
            <div>Destino: {{ storageMovement.relatedStorageMovement?.storage?.name }}</div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!storageMovement.relatedStorageMovement">
          <div>Depósito: {{ storageMovement.storage?.name || storageMovement.externalStorage?.name }}</div>
        </ng-container>
        <div>Quantidade: {{ storageMovement.quantity.current }}</div>
      </div>
      <div class="card__body__quantity__icon" (click)="openStorageMovementDetails()">
        <mat-icon>open_in_new</mat-icon>
      </div>
    </div>
  </div>
</div>
